var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}},[_c('path',{attrs:{"d":"M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }